<template>
  <v-card class="lean-embedded-document mx-auto my-4" max-width="1000" :rounded="false" outlined>
    <v-toolbar color="blue-grey lighten-1" dark flat dense>
      <v-toolbar-title>{{ label }}</v-toolbar-title>
      <v-spacer v-if="!value" />
      <v-btn v-if="!value" icon @click="openDialog" :disabled="disabled">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container v-if="value" fluid class="px-10 py-5">
      <v-list-item class="px-0">
        <lean-list-item-content @click="openDialog" :record="value" :listConfig="listConfig" />
        <v-list-item-action>
          <div class="d-flex">
            <v-btn v-if="!disabled" icon @click="openDialog">
              <v-icon color="grey lighten-1"> mdi-pencil </v-icon>
            </v-btn>
            <v-btn v-if="!disabled" icon @click="value = embeddedValue = null">
              <v-icon color="grey lighten-1"> mdi-delete </v-icon>
            </v-btn>
          </div>
        </v-list-item-action>
      </v-list-item>
    </v-container>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card :rounded="false">
        <v-toolbar color="blue-grey lighten-1" dark flat dense>
          <v-btn @click="dialog = false" rounded icon>
            <v-icon color="white"> mdi-close </v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn rounded icon @click="copyEmbeddedValuesToFieldValue">
            <v-icon color="white"> mdi-content-save </v-icon>
          </v-btn>
        </v-toolbar>
        <v-container>
          <v-card-text>
            <lean-form-block
              :initialValues="embeddedValue"
              :schema="schema"
              :resolved="resolved"
              @change="updateEmbeddedValue($event)"
              class="px-8"
              :key="dialogKey"
            />
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import fieldMixin from '@/mixins/LeanField';
import { mapState } from 'vuex';
import LeanListItemContent from '@/components/LeanListItemContent.vue';

export default {
  name: 'LeanEmbeddedDocument',
  mixins: [fieldMixin],
  components: {
    LeanListItemContent,
    LeanFormBlock: () => import('@/components/LeanFormBlock.vue')
  },
  data: () => ({
    dialog: false,
    embeddedValue: null,
    // Using an incrementing unique key forces the re-rendering of the dialog form-block component
    dialogKey: 0
  }),
  watch: {
    dialog() {
      // When no initial value was set, then we need to create and empty the current value to
      // be able to populate the FormBlock with FormFields
      if (this.value === null) {
        this.embeddedValue = {};
        this.datatypes[this.config.source].schema.map((field) => {
          this.embeddedValue[field.name] = null;
        });
      } else {
        this.embeddedValue = Object.assign({}, this.value);
      }
    }
  },
  methods: {
    openDialog() {
      this.dialogKey++;
      this.dialog = true;
    },
    updateEmbeddedValue(data) {
      this.isModified = true;
      // TODO: what would happen if data included a newAttachment? How to pass this up the chain?
      Object.keys(data.values).map((fieldName) => {
        this.embeddedValue[fieldName] = data.values[fieldName];
      });
    },
    copyEmbeddedValuesToFieldValue() {
      this.value = Object.assign({}, this.embeddedValue);
      this.dialog = false;
    }
  },
  computed: {
    ...mapState({
      datatypes: (state) => state.models
    }),
    schema: {
      get() {
        return this.datatypes[this.config.source].schema;
      }
    },
    listConfig: {
      get() {
        return this.datatypes[this.config.source].list || null;
      }
    }
  }
};
</script>
<style lang="scss">
.lean-embedded-document .lean-list-item-content {
  cursor: pointer;
}
</style>
